import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import cn from 'classnames';

const ResourceItem = ({
  iconName,
  children,
  className,
  iconClassName = '',
}) => {
  const styles = cn('flex items-center py-6 px-3 hover:bg-blue-100', className);
  return (
    <div className={styles}>
      {iconName && (
        <div className="mr-4 self-start">
          <Icon
            id={iconName}
            className={iconClassName}
            accessibility={{ ariaHidden: true }}
          />
        </div>
      )}
      {children}
    </div>
  );
};

ResourceItem.propTypes = {
  iconName: PropTypes.string,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
};

export default ResourceItem;
